import { render, staticRenderFns } from "./VueFooter.vue?vue&type=template&id=73e0ef44&scoped=true&"
import script from "./VueFooter.vue?vue&type=script&lang=js&"
export * from "./VueFooter.vue?vue&type=script&lang=js&"
import style0 from "./VueFooter.vue?vue&type=style&index=0&id=73e0ef44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e0ef44",
  null
  
)

export default component.exports